import { render, staticRenderFns } from "./PrivacyPolicyPopUp.vue?vue&type=template&id=2d08e79a&scoped=true&"
import script from "./PrivacyPolicyPopUp.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyPopUp.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyPopUp.vue?vue&type=style&index=0&id=2d08e79a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08e79a",
  null
  
)

export default component.exports